import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1A3A5F] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Column 1 - About */}
          <div>
            <h3 className="text-xl font-bold mb-4">M7 CORP</h3>
            <p className="mb-4">
              Grupo empresarial especializado em soluções de engenharia, inspeção e integridade para o setor industrial.
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#4D8BC9] transition-colors">
                <Facebook size={20} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#4D8BC9] transition-colors">
                <Instagram size={20} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#4D8BC9] transition-colors">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Column 2 - Empresas */}
          <div>
            <h3 className="text-xl font-bold mb-4">Empresas</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/maintech" className="hover:text-[#4D8BC9] transition-colors">MAIN'TECH PLUS</Link>
              </li>
              <li>
                <Link to="/iadg" className="hover:text-[#4D8BC9] transition-colors">IADG EXPERTS</Link>
              </li>
              <li>
                <Link to="/sobre" className="hover:text-[#4D8BC9] transition-colors">Sobre o Grupo</Link>
              </li>
              <li>
                <Link to="/certificacoes" className="hover:text-[#4D8BC9] transition-colors">Certificações</Link>
              </li>
              <li>
                <Link to="/cases" className="hover:text-[#4D8BC9] transition-colors">Cases</Link>
              </li>
            </ul>
          </div>

          {/* Column 3 - Serviços */}
          <div>
            <h3 className="text-xl font-bold mb-4">Serviços</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/servicos/inspecao" className="hover:text-[#4D8BC9] transition-colors">Inspeção</Link>
              </li>
              <li>
                <Link to="/servicos/integridade" className="hover:text-[#4D8BC9] transition-colors">Integridade</Link>
              </li>
              <li>
                <Link to="/servicos/ensaios" className="hover:text-[#4D8BC9] transition-colors">Ensaios</Link>
              </li>
              <li>
                <Link to="/servicos/normativas" className="hover:text-[#4D8BC9] transition-colors">Normativas</Link>
              </li>
              <li>
                <Link to="/servicos/calculo" className="hover:text-[#4D8BC9] transition-colors">Cálculo</Link>
              </li>
              <li>
                <Link to="/servicos/manutencao" className="hover:text-[#4D8BC9] transition-colors">Manutenção</Link>
              </li>
              <li>
                <Link to="/servicos/engenharia" className="hover:text-[#4D8BC9] transition-colors">Engenharia</Link>
              </li>
            </ul>
          </div>

          {/* Column 4 - Contato */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin size={20} className="mr-2 mt-1 flex-shrink-0" />
                <span>Av. Industrial, 1000, Centro<br />São Paulo - SP, 01000-000</span>
              </li>
              <li className="flex items-center">
                <Phone size={20} className="mr-2 flex-shrink-0" />
                <span>(11) 5555-5555</span>
              </li>
              <li className="flex items-center">
                <Mail size={20} className="mr-2 flex-shrink-0" />
                <a href="mailto:contato@m7corp.com.br" className="hover:text-[#4D8BC9] transition-colors">contato@m7corp.com.br</a>
              </li>
              <li className="mt-4">
                <Link 
                  to="/contato" 
                  className="bg-[#4D8BC9] hover:bg-[#3A6A9A] text-white font-bold py-2 px-4 rounded transition-colors inline-block"
                >
                  Fale Conosco
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p>&copy; {new Date().getFullYear()} M7 CORP. Todos os direitos reservados.</p>
          <div className="mt-4 md:mt-0">
            <ul className="flex space-x-6">
              <li>
                <Link to="/politica-privacidade" className="hover:text-[#4D8BC9] transition-colors">Política de Privacidade</Link>
              </li>
              <li>
                <Link to="/termos-uso" className="hover:text-[#4D8BC9] transition-colors">Termos de Uso</Link>
              </li>
              <li>
                <Link to="/cliente-area" className="hover:text-[#4D8BC9] transition-colors">Área do Cliente</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
